import { Component, OnInit, AfterViewInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
//Import Custom Services Here
import { SchoolGroupService } from "../report-services/school-group.service";
import { UserService } from "../../../shared";
declare var moment: any;

@Component({
	templateUrl: "./visitorsummary.component.html",
})
export class VisitorSummaryComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private schoolgroupService: SchoolGroupService,
		private dialogService: DialogService,
		private userService: UserService
	) {}
	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		SchoolGroupID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		PeriodID: "Today",
		SchoolVisitStatusID: "All",
		ShowContainerID: "Yes",
		OrderByID: "container",
		ImageLogo: "",
	};
	//Insert Custom Lists Here
	SchoolGroupList: any = [];
	ImageLogoList: any = [];

	subscription: any;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	PeriodList = [
		//Insert Custom List Items Here
		{
			PeriodID: "Today",
			PeriodName: "Today",
		},
		{
			PeriodID: "Current week",
			PeriodName: "Current week",
		},
		{
			PeriodID: "Current month",
			PeriodName: "Current month",
		},
		{
			PeriodID: "Date range",
			PeriodName: "Date range",
		},
	];

	SchoolVisitStatusList = [
		//Insert Custom List Items Here
		{
			SchoolVisitStatusID: "All",
			SchoolVisitStatusName: "All",
		},
		{
			SchoolVisitStatusID: "Only with visitors",
			SchoolVisitStatusName: "Only with visitors",
		},
		{
			SchoolVisitStatusID: "No visitors",
			SchoolVisitStatusName: "No visitors",
		},
	];

	ShowContainerList = [
		//Insert Custom List Items Here
		{
			ShowContainerID: "Yes",
			ShowContainerName: "Yes",
		},
		{
			ShowContainerID: "No",
			ShowContainerName: "No",
		},
	];

	OrderByList = [
		//Insert Custom List Items Here
		{
			OrderByID: "container",
			OrderByName: "container",
		},
		{
			OrderByID: "school number",
			OrderByName: "school number",
		},
		{
			OrderByID: "school name",
			OrderByName: "school name",
		},
		{
			OrderByID: "visit count",
			OrderByName: "visit count",
		},
		{
			OrderByID: "require verification count",
			OrderByName: "require verification count",
		},
		{
			OrderByID: "deny entry count",
			OrderByName: "deny entry count",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".csv (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 395;

	ngOnInit() {
		this.user = this.userService.getCurrentUser();
		//Insert Custom Init Methods Here
		this.loadSchoolGroupList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(val) {
		this.report.SchoolID = val;

		this.loadLogolist();
	}

	private loadSchoolGroupList() {
		this.report.SchoolGroupID = 0;
		var result = this.schoolgroupService.loadSchoolGroupList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.SchoolGroupList = response;

				this.report.SchoolGroupID = this.SchoolGroupList[0].SchoolGroupID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.SchoolGroupID) {
		// 	this.errorMessage = "Select the SchoolGroup"
		// 	return;
		// }

		// if (!this.report.StartDate) {
		// 	this.errorMessage = "Select the StartDate"
		// 	return;
		// }

		// if (!this.report.EndDate) {
		// 	this.errorMessage = "Select the EndDate"
		// 	return;
		// }

		// if (!this.report.PeriodID) {
		// 	this.errorMessage = "Select the Period"
		// 	return;
		// }

		// if (!this.report.SchoolVisitStatusID) {
		// 	this.errorMessage = "Select the SchoolVisitStatus"
		// 	return;
		// }

		// if (!this.report.ShowContainerID) {
		// 	this.errorMessage = "Select the ShowContainer"
		// 	return;
		// }

		// if (!this.report.OrderByID) {
		// 	this.errorMessage = "Select the OrderBy"
		// 	return;
		// }

		// if (!this.report.UserID) {
		// 	this.errorMessage = "Select the User"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 395;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolGroupID
		strParam += this.report.SchoolGroupID + "|SchoolGroupID";

		//Parameter 2: StartDate
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 3: EndDate
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 4: Period
		strParam += "," + this.report.PeriodID + "|Period";

		//Parameter 5: SchoolVisitStatus
		strParam += "," + this.report.SchoolVisitStatusID + "|SchoolVisitStatus";

		//Parameter 6: ShowContainer
		strParam += "," + this.report.ShowContainerID + "|ShowContainer";

		//Parameter 7: OrderBy
		strParam += "," + this.report.OrderByID + "|OrderBy";

		//Parameter 8: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		//Parameter 9: UserID
		strParam += "," + this.user.userID + "|UserID";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
